import { useTranslation } from 'react-i18next'
import { useFormatNumber } from 'core/hooks/useFormatNumber'

interface ProductivityContentProps {
  targetProductivity?: number
  productivity: number
  isInstore: boolean
}

const ProductivityContent = ({ targetProductivity, productivity, isInstore }: ProductivityContentProps) => {
  const { t } = useTranslation()
  const formatNumber = useFormatNumber()
  const productivityGap = productivity - targetProductivity

  return (
    <div className="productivity-content" data-testid="productivity-content">
      <span className="vp-subtitle-m" data-testid="productivity-value">
        {formatNumber(productivity, '--', { maximumFractionDigits: 1 })}
      </span>
      {isInstore && (
        <>
          {!!targetProductivity && (
            <span
              data-testid="productivity-gap"
              className={`vp-caption mg-target-productivity-gap ${productivityGap < 0 ? 'mg-target-productivity-gap__negative' : 'mg-target-productivity-gap__positive'}`}
            >
              {formatNumber(productivityGap, '--', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
                signDisplay: 'always'
              })}
            </span>
          )}
          <span className="vp-caption target-productivity" data-testid="target-productivity">
            ({t('general.homepage.target-productivity.read.label')}{' '}
            {formatNumber(targetProductivity, '--', { maximumFractionDigits: 1 })})
          </span>
        </>
      )}
    </div>
  )
}

export default ProductivityContent
